import React, { type FC, useEffect, useState } from 'react'
import { FetchCompaniesAction } from '../../../redux/admin/admin-companies-actions'
import { makeStyles } from 'tss-react/mui'
import { useAppDispatch, useAppSelector } from '../../../redux/hooks'
import { type RootState } from '../../../redux/store'
import { CompanyIntegrationCard } from './CompanyIntegrationCard'

const useStyles = makeStyles()((theme) => {
  return {
    expand: {
      transform: 'rotate(0deg)',
      marginLeft: 'auto',
      transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest
      })
    },
    expandOpen: {
      transform: 'rotate(90deg)'
    },
    textField: {
      marginBottom: '10px',
      marginTop: '10px'
    }
  }
})

/**
 * Admin view for managing company integrations related configurations.
 */
export const CompanyIntegrations: FC = () => {
  const dispatch = useAppDispatch()

  const companies = useAppSelector((state: RootState) => state.admin.companies)

  const [expanded, setExpanded] = useState({})
  const { classes } = useStyles()

  useEffect(() => {
    dispatch(FetchCompaniesAction())
  }, [dispatch])

  const sortedCompanies = companies.slice().sort((a, b) => a.name.localeCompare(b.name))

  return (
        <div style={{ margin: '0 auto', paddingTop: '20px', paddingBottom: '100px', width: '600px' }}>
            {sortedCompanies.map((company) => {
              return (<CompanyIntegrationCard
                        key={company.id}
                        company={company}
                        classes={classes}
                        isExpanded={expanded[company.id] ?? false}
                        onExpandStateChange={(company, expand) => {
                          setExpanded({ ...expanded, [company.id]: expand })
                        }}
                    />
              )
            })}
        </div>
  )
}
